import DesignSystemPreview from './DesignSystemPreview';

export default DesignSystemPreview;
